import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';

function AdminSubCategories() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [categoriess, setCategoriess] = useState([]);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const maincatname = e.target.maincatname.value;
    const subCategoryName = e.target.subCategoryName.value;
  
    try {
      const response = await fetch(`${apiUrl}/public/saveSubCategories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ subcatname: subCategoryName ,maincatname:maincatname}),
      });
  
      if (response.ok) {
        const data = await response.json();
        alert(`Sub Category "${data.subcatname}" has been successfully added!`);
        e.target.reset();
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error adding category:', error);
      alert('An unexpected error occurred. Please try again later.');
    }
  };
    useEffect(() => {
      fetch(`${apiUrl}/public/allCategories`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch categories');
          }
          return response.json();
        })
        .then((data) => {
          console.log('Fetched categories:', data); // Check the output here
          setCategoriess(data);
        })
        .catch((error) => console.error('Error fetching categories:', error));
    }, []);

  return (
    <Flex h="100vh" bg="gray.100">
      {/* Sidebar */}
   

      {/* Content Area */}
      <Box flex="1" p={4}>
        {/* Header */}
        <Flex
          justify="space-between"
          align="center"
          bg="white"
          p={4}
          mb={4}
          borderRadius="md"
          shadow="sm"
        >
          <IconButton
            icon={<FiMenu />}
            aria-label="Open menu"
            display={{ base: 'block', md: 'none' }}
            onClick={onOpen}
          />
          <Text fontSize="xl" fontWeight="bold">
           Sub Categories Management
          </Text>
        </Flex>

        {/* Form Section */}
        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Category
          </Text>
          <form onSubmit={handleFormSubmit}>
            <VStack spacing={4} align="stretch">
              <FormControl id="subCategoryName" isRequired>
                <FormLabel>Sub Category Name</FormLabel>
                <Input
                  type="text"
                  placeholder="Enter Sub Category "
                  name="subCategoryName"
                />
              </FormControl>
             <FormControl id="maincatname" isRequired>
               <FormLabel>Select Category</FormLabel>
               <select  name="maincatname">
                 <option >Select Categories</option>
                 {categoriess.length > 0 ? (
                   categoriess.map((categorys) => (
                     <option key={categorys.catId} value={categorys.maincatname}>
                       {categorys.maincatname}
                     </option>
                   ))
                 ) : (
                   <option value="">No categories available</option>
                 )}
               </select>
             </FormControl>
              <Button type="submit" colorScheme="teal" width="full">
              Save
              </Button>
            </VStack>
          </form>
        </Box>
       
      </Box>
        </Flex>
  );
}

export default AdminSubCategories;
